let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("lK1GY")).then(() => parcelRequire('vtgYF'));